<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Tag" });
import Icon from "../../elements/icon/Icon.svelte";
import "tailwindcss/tailwind.css";
import { createEventDispatcher } from "svelte";
const dispatch = createEventDispatcher();
export let key;
export let isDisabled = false;
export let mode = "remove";
export let css = "";
const onClick = () => {
    if (isDisabled) {
        return;
    }
    dispatch(mode, { key });
};
$: style = `s8-tag s8-${mode} ${css}`;
</script>

<span
    class = { style }
    class:s8-disabled = { isDisabled }
    on:click = { onClick }
    on:keypress = { onClick }>

    <Icon key = { mode === 'add' ? 'plus' : 'close' } isScaling = { false } />
    <slot>Hello World</slot>
</span>

<style>

    span.s8-tag {
        position: relative;
        display: block;
        height: 20px;
        padding: 0px 5px;
        border-radius: 4px;

        font-size: 9px;
        line-height: 20px;

        cursor: pointer;
        -webkit-user-select: none;
           -moz-user-select: none;
                user-select: none;
    }

        span.s8-tag :global(svg) {
            position: absolute;
            height: 8px;
            top: 50%;
            transform: translateY(-50%);
        }

        span.s8-tag :global(svg path) {
        stroke: rgba(39, 39, 17, 1);

            stroke-width: 1.2px;
}

        span.s8-tag.s8-disabled {
           cursor: default;
        }

        span.s8-tag.s8-add {
        background-color: rgba(231, 231, 230, 1);
        color: rgba(39, 39, 17, 1);

            padding-left: 15px;
}

        span.s8-tag.s8-add :global(svg) {
                left: 5px;
            }

        span.s8-tag.s8-add.s8-disabled {
        color: rgba(193, 192, 189, 1);
}

        span.s8-tag.s8-add.s8-disabled :global(svg path) {
        stroke: rgba(193, 192, 189, 1);
}

        span.s8-tag.s8-remove {
        background-color: rgba(161, 193, 175, 1);
        color: rgba(39, 39, 17, 1);

            padding-right: 15px;
            background-color: rgba(68,131,95,0.24);
}

        span.s8-tag.s8-remove :global(svg) {
                right: 5px;
            }

        span.s8-tag.s8-remove.s8-disabled {
        background-color: rgba(199, 218, 207, 1);
        color: rgba(161, 193, 175, 1);
}

        span.s8-tag.s8-remove.s8-disabled :global(svg path) {
        stroke: rgba(161, 193, 175, 1);
}</style>